"use strict";

/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DealsService = void 0;
var DealsService;
(function (DealsService) {
  /**
   * @title YOL Service
   * @version 1.0.10
   * @license MIT
   * @baseUrl /deals
   * @contact YOL Digital <digital-yol@sunrise.net>
   *
   * YOL DEALS MICROSERVICE
   */
  class Api {
    constructor(url, http) {
      this.public = {
        /**
        * No description
        *
        * @name GetDealsForAccountId
        * @request GET:/deals/deals/account
        * @secure bearerAuth
        * @response `200` `DealsResp` Ok
        * @response `404` `{
        error: "ERR_NOT_ACTIVE_SUBS_FOUND",
             }`
        * @response `500` `{
        error: "ERR_FROM_POE_API" | "ERR_SYSTEM_ERROR",
             }`
        */
        getDealsForAccountId: (params = {}) => this.http.request("GET", `${this.url}/deals/deals/account`, {
          ...params
        })
      };
      this.http = http;
      this.url = url;
    }
  }
  DealsService.Api = Api;
})(DealsService || (exports.DealsService = DealsService = {}));